// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ac7f537e","982":"308b3cc9"}[chunkId] + ".chunk.js";
};